import type { ContractAppProfileDto } from "src/app/features/Contract/types/subTypes/ContractAppProfileDto";
import { AcceptMode, type ContractAppProfileEntity } from "src/app/features/Contract/types/subTypes/ContractAppProfileEntity";
import type { ContractDto } from "../../types/ContractDto";
import type { ContractEntity } from "../../types/ContractEntity";

export const acceptedModeMapper = (contractAppProfile: ContractAppProfileDto) => {
    const { online, offline, degraded } = contractAppProfile;
    /*
            There are conditions for checking those check boxes based on business requirement.
            This allows user to set up following conditions: online, online - offline, online - offline - degraded.

            Is never possible to have offline acceptance mode without online option selected first, the same in case of degraded.
            Degraded mode is possible only when offline and online is selected first.
         */
    let acceptMode = "";
    if (degraded) {
        acceptMode = AcceptMode.DEGRADED.value;
    } else if (offline) {
        acceptMode = AcceptMode.OFFLINE.value;
    } else if (online) {
        acceptMode = AcceptMode.ONLINE.value;
    }

    return { ...contractAppProfile, acceptMode };
};

export const ContractDtoToEntity = ({ acceptedCardProfiles, ...rest }: Readonly<ContractDto>): ContractEntity => {
    const newContractAppProfiles: ContractAppProfileEntity[] =
        acceptedCardProfiles?.map((contractAppProfile) => {
            return acceptedModeMapper(contractAppProfile);
        }) || [];

    let physicalAppProfilesCheckReadOnly = false;
    let acceptedCardProfilesCheckReadOnly = false;
    if (!rest.physical) {
        physicalAppProfilesCheckReadOnly = true;
        acceptedCardProfilesCheckReadOnly = true;
    }

    return { ...rest, acceptedCardProfiles: newContractAppProfiles, physicalAppProfilesCheckReadOnly, acceptedCardProfilesCheckReadOnly };
};
